module.exports = __webpack_public_path__ + "static/img/硕士_2021_谷世豪_gshao_907@nwafu.edu.cn.e3b1ba5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/硕士_2021_谷世豪_gshao_907@nwafu.edu.cn.jpg
// module id = 8zh4
// module chunks = 6